const items = [
	{
		id: 0,
		key: 0,
		name: "status.waiting"
	},
	{
		id: 1,
		key: 1,
		name: "status.active"
	},
	{
		id: 3,
		key: 3,
		name: "status.inActive"
	},
	{
		id: 4,
		key: 4,
		name: "status.approved"
	},
	{
		id: -1,
		key: -1,
		name: "status.rejected"
	}
];

export default items;